import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const CloseSquare: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path fill="#fff" d="M8 8h16v16H8z" />
    <path
      fill="currentColor"
      d="M30 30H2V2h28v28Zm-8.2-19.8a.667.667 0 0 0-.944 0l-4.86 4.863-4.863-4.863a.667.667 0 1 0-.943.944l4.862 4.86-4.862 4.863a.666.666 0 1 0 .943.943l4.862-4.862 4.861 4.862a.667.667 0 0 0 .944-.943l-4.863-4.862 4.863-4.861a.667.667 0 0 0 0-.944Z"
    />
  </Icon>
);
